<template>
  <DBox
    :id="'cmp-distribution-statement-sidewindow-catalog'"
    :addButton="false"
    :addLink="false"

    @menuClick="onRightMenuClick"
  >
      <!-- :rightMenu="[
      {
        text: $t('invoice_statement'),
        value: 'invoice_statement',
      },
      {
        text: $t('refresh'),
        value: 'refresh',
      },
      {
        text: $t('price_export'),
        value: 'price_export',
      },
    ]" -->
    <!-- @add_click="onAddArtist" -->
    <!-- :expandable="true" -->
    <NTable
      class="dbox1"
      id="distribution-statement-catalog"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('catalog_no')">
            <span>{{ item['catalog_no'] }}</span>
          </td>
          <td v-bind="tdcon('format')">
            <span>{{ item['format_name'] }}</span>
          </td>
          <td v-bind="tdcon('sales')">
            <span>{{ item['sales'] }}</span>
          </td>
          <td v-bind="tdcon('returns')">
            <span>{{ item['returns'] }}</span>
          </td>
          <td v-bind="tdcon('promo_foc')">
            <span>{{ item['promo_foc'] }}</span>
          </td>
          <td v-bind="tdcon('turnover')">
            <span>{{ item['turnover'] }}</span>
          </td>
          <td v-bind="tdcon('avg_ppu')">
            <span>{{ item['avg_ppu'] }}</span>
          </td>

        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { distributionAccountListLDTRoutes } from '../../router/routes';
import { distributionStatementsActions } from '../../store/statement/actions';
import { DistributionStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import {
  mapGetterObject,
  mapActionObject,
} from "../../../../store/global";
export default {
  props: {
    selectedStatementDetails: {
      type: Object
    }
  },
  components: {
    NTable,
    DBox
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },

      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      })
    };
  },
  computed: {
    Headers: function() {
      return [
        createTableHeader("catalog_no", {}),
        createTableHeader("format", {}),
        createTableHeader("sales", { ta:'right'}),
        createTableHeader("returns", { ta:'right'}),
        createTableHeader("promo_foc", { ta:'right'}),
        createTableHeader("turnover", { ta:'right'}),
        createTableHeader("avg_ppu", { ta:'right'}),
        
      ];
    },

    list: function() {
      return this.selectedStatementDetails.catalogs || [];
    },


  },
  methods: {
     ...mapActionObject(storeNS, distributionStatementsActions),
    onRightMenuClick:async function(menu) {
       this.$emit('menuClick',menu)
      // switch(menu) {
      //   case 'invoice_statement': {
      //     const { account_id }=this.selectedStatementDetails.statement

      //     this.$router.push({
      //       name: distributionAccountListLDTRoutes.names.tab,
      //       params: {
      //         account_id: account_id,
      //         tab: "current_statements",
      //       },
      //     });
          
      //     break;
      //   }
      //   case 'refresh': {
      //     this[ActionTypes.DistributionStatementImportResultTotal.UPDATE.SINGLE]({...this.selectedStatementDetails.statement});
      //     break;
      //   }
      //   case 'price_export': {

      //   }

      // }
    }
  }
};
</script>
<style lang="scss">
.cmp-distribution-statement-sidewindow-catalog {
  .dt-ntable tbody tr:last-child {
    border-bottom: 0;
  }
}
</style>